export type CompanyPlan = 'DECOUVERTE' | 'ARTISAN' | 'PRO_BTP' | 'ENTERPRISE';

export const PLAN_LABELS: Record<CompanyPlan, string> = {
  DECOUVERTE: 'Découverte',
  ARTISAN: 'Artisan',
  PRO_BTP: 'Pro BTP',
  ENTERPRISE: 'Entreprise',
};

export const ALL_PLANS: CompanyPlan[] = ['DECOUVERTE', 'ARTISAN', 'PRO_BTP', 'ENTERPRISE'];
